import { createFrontendTracker } from './typedTracker'
import type { AnalyticsEvents } from '@omnea-app/packages/universal/analytics'

/**
 * Module-level singleton tracker. Safe to use at import time — the underlying
 * Segment client is lazily resolved via a promise, so early calls are buffered.
 */
const tracker = createFrontendTracker<AnalyticsEvents>()

/** Typed track function for analytics events. Works in React components and plain functions. */
export const track = tracker.track
